import { useEffect, useState } from "react";

const imageStatusCache = new Map();

export const useResolvedImageSrc = (src, fallbackSrc) => {
  const [resolvedSrc, setResolvedSrc] = useState(() => {
    if (!src) {
      return fallbackSrc;
    }

    const cachedStatus = imageStatusCache.get(src);
    if (cachedStatus === "loaded") {
      return src;
    }

    return fallbackSrc;
  });

  useEffect(() => {
    if (!src) {
      setResolvedSrc(fallbackSrc);
      return;
    }

    const cachedStatus = imageStatusCache.get(src);
    if (cachedStatus === "loaded") {
      setResolvedSrc(src);
      return;
    }

    if (cachedStatus === "error") {
      setResolvedSrc(fallbackSrc);
      return;
    }

    let isActive = true;
    const image = new Image();

    image.onload = () => {
      imageStatusCache.set(src, "loaded");
      if (isActive) {
        setResolvedSrc(src);
      }
    };

    image.onerror = () => {
      imageStatusCache.set(src, "error");
      if (isActive) {
        setResolvedSrc(fallbackSrc);
      }
    };

    image.src = src;

    return () => {
      isActive = false;
    };
  }, [src, fallbackSrc]);

  return resolvedSrc;
};
